<template lang="pug">
  .ok-cancel-modal
    b-modal(v-model="_value" :size="size" hide-header @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
      .default-modal-body.register-body
        .mb-2
        FormInputSelect(v-model="_facilityId" key-name="ログインする施設を選択してください" name="facility"
          :options="facilityOptions" :styles="_selectStyle")

      template(#modal-footer="{ ok, cancel }")
        b-button.btn.modal-ok-btn(@click="ok" :class="{ 'disable': !facilityId }" :disabled="!facilityId") {{ okButtonLabel }}
        b-button.btn.modal-cancel-btn(@click="cancel") {{ cancelButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";

/**
 * ### 施設選択モーダル
 */
@Component({
  components: {
    FormInputSelect
  }
})
export default class FacilitySelectModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "md" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "OK" })
  okButtonLabel!: string;
  /** キャンセルボタンラベル */
  @Prop({ default: () => "キャンセル" })
  cancelButtonLabel!: string;

  @Prop({ default: () => "pc" })
  type!: string;

  @Prop()
  facilityId!: number;

  @Prop({ default: () => [] })
  facilityOptions!: Array<{ value: number | string; label: string }>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _facilityId(): number {
    return this.facilityId;
  }

  set _facilityId(newValue: number) {
    this.$emit("update:facilityId", newValue);
    return;
  }

  get _selectStyle() {
    if (this.type == "mobile") {
      return { width: "330px", "max-width": "330px" };
    } else {
      return { width: "430px", "max-width": "430px" };
    }
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
</script>
